import { ScaffoldingFile, ScaffoldingFileContent } from "../ScaffoldingFile";

export interface TemplateFile extends ScaffoldingFile {
  content: ScaffoldingFileContent;
}

export type TemplateFileOptions = Omit<ScaffoldingFile, "getContent">;

export function templateFile(
  content: ScaffoldingFileContent,
  options?: TemplateFileOptions,
): TemplateFile {
  return {
    ...options,
    content,
    getContent: templateFileContent,
  } as TemplateFile;
}

function templateFileContent(this: TemplateFile): ScaffoldingFileContent {
  return this.content;
}
